import React, { useEffect } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useGetCallCredentialsQuery, useUpdateCallCredentialsMutation } from './Api'
import Loader from "../loader/loader";
import toastService from "../../services/toastService";

const CallSettings = () => {

    const validationSchema = Yup.object().shape({
        providerUrl: Yup.string()
            .required('Provider URL is required')
            .url('Enter a valid URL')
            .max(200, 'Provider URL is too long')
            .trim(),
        providerNumber: Yup.string()
            .required('Provider number is required')
            .matches(
                /^\+?[0-9]+$/,
                'Provider number must contain only numbers and an optional + symbol'
            )
            .min(10, 'Provider number must be at least 10 digits')
            .max(16, 'Provider number cannot exceed 15 digits')
            .trim(),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    const { data, isLoading } = useGetCallCredentialsQuery()

    const [updateCredentialsApi, { isLoading: updateIsLoading }] = useUpdateCallCredentialsMutation()


    useEffect(() => {

        if (data?.data) {
            reset({
                providerUrl: data.data.provider_url,
                providerNumber: data.data.provider_number,
            })
        }

    }, [data])

    const handleOnSubmit = async (data) => {
        try {

            const payload = {
                provider_url: data.providerUrl,
                provider_number: data.providerNumber,
            }

            const updateApiResponse = await updateCredentialsApi(payload)

            if (updateApiResponse?.data?.success) {
                toastService.success(updateApiResponse.data.message);
            } else {
                toastService.error(updateApiResponse.error.data.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <div className="smtp-wrapper">

                    <div className="smtp-card">
                        <form onSubmit={handleSubmit(handleOnSubmit)}>

                            <div className="d-flex justify-content-between align-items-center mb-4">

                                <div>
                                    <h3 className="fw-bold mb-1">
                                        Call Settings
                                    </h3>

                                    <p className="text-muted mb-0">
                                        Configure your Call credentials
                                    </p>
                                </div>

                                <button className="btn btn-primary" type='submit'>
                                    Save Changes
                                </button>

                            </div>
                            <div className="row">

                                <div className="col-md-6 smtp-field">
                                    <label>Provider URL</label>
                                    <input type="text"
                                        id="providerUrl"
                                        name='providerUrl'
                                        {...register('providerUrl')}
                                        className="form-control"
                                        placeholder="Enter Provider URL" />
                                    {errors.providerUrl && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.providerUrl.message}
                                        </p>
                                    )}
                                </div>

                                <div className="col-md-6 smtp-field">
                                    <label>Number</label>
                                    <input type="text"
                                        id="providerNumber"
                                        name='providerNumber'
                                        {...register('providerNumber')}
                                        className="form-control"
                                        placeholder="Enter Number" />
                                    {errors.providerNumber && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.providerNumber.message}
                                        </p>
                                    )}
                                </div>
                            </div>

                        </form>

                    </div>

                </div>
            }
        </div>

    )
}

export default CallSettings
